import jwt_decode from 'jwt-decode'
import { ls, sendSlackMessage } from '../index'
import { toaster } from 'evergreen-ui'
const cookieName = process.env.REACT_APP_AUTH_COOKIE || 'cademyAdminToken'

const getUserDetails = () => {
  const authToken = ls.getItem(cookieName)
  let decodedToken = authToken ? jwt_decode(authToken) : {}
  let educator_ref = decodedToken?.educator_ref ?? null

  return {
    ...decodedToken,
    educator_ref
  }
}

const toasterService = {
  success: (msg, desc, opts = {}) =>
    toaster.success(msg, { description: desc, ...opts }),
  danger: (msg, desc, opts = {}, err) => {
    const userDetails = getUserDetails()
    toaster.danger(msg, { description: desc, ...opts })
    window.analytics.track('Danger alert', {
      message: msg,
      description: desc,
      ...opts
    })
    if (!opts?.dontSlack) {
      sendSlackMessage(
        'Danger Toaster',
        ':bangbang:',
        `*Toaster Message:* ${msg}\n*User:* ${userDetails?.first_name} ${userDetails?.last_name}\n*Email:* ${userDetails?.email}\n*Account:* ${userDetails?.educator_ref}`,
        '#system-events',
        err
      )
    }
  },
  notify: (msg, desc, opts = {}) =>
    toaster.notify(msg, { description: desc, ...opts }),
  warning: (msg, desc, opts = {}) => {
    const userDetails = getUserDetails()
    toaster.warning(msg, { description: desc, ...opts })
    window.analytics.track('Warning alert', {
      message: msg,
      description: desc,
      ...opts
    })
    if (!opts?.dontSlack) {
      sendSlackMessage(
        'Warning Toaster',
        ':warning:',
        `*Toaster Message:* ${msg}\n*User:* ${userDetails?.first_name} ${userDetails?.last_name}\n*Email:* ${userDetails?.email}\n*Account:* ${userDetails?.educator_ref}`
      )
    }
  }
}

export default toasterService
